<template>
  <div class="popup-config">
    <FormItem label="活动推送配置：" :label-width="120">
      <Select
        v-model="selectedRuleId"
        clearable
        filterable
        placeholder="请选择已有配置（作为模板）"
        :disabled="disabled"
        :loading="ruleLoading"
        @on-change="handleRuleChange"
      >
        <Option
          v-for="item in ruleOptions"
          :key="item.id"
          :value="item.id"
          :label="item.popupRuleName"
        >
          {{ item.popupRuleName }}
        </Option>
      </Select>
    </FormItem>

    <div class="group-list">
      <div class="group-card">
        <h3 class="group-title">对照组</h3>
        <div class="group-fields">
          <FormItem label="用户停留时长" :label-width="120">
            <div class="duration-row">
              <Select
                v-model="controlGroup.watchingDurationType"
                :disabled="disabled"
                style="width: 150px"
                @on-change="handleDurationTypeChange(controlGroup)"
              >
                <Option
                  v-for="item in durationTypeOptions"
                  :key="item.dictValue"
                  :value="Number(item.dictValue)"
                >
                  {{ item.dictName }}
                </Option>
              </Select>
              <template v-if="showDurationInput(controlGroup)">
                <InputNumber
                  v-model="controlGroup.durationMin"
                  :min="controlGroup.watchingDurationType === 2 ? 1 : 0"
                  :max="9999"
                  :precision="0"
                  :disabled="disabled"
                  style="width: 100px; margin-left: 10px"
                />
                <span
                  v-if="showDurationRange(controlGroup)"
                  style="margin: 0 5px"
                  >至</span
                >
                <InputNumber
                  v-if="showDurationRange(controlGroup)"
                  v-model="controlGroup.durationMax"
                  :min="0"
                  :max="9999"
                  :precision="0"
                  :disabled="disabled"
                  style="width: 100px"
                />
                <span style="margin-left: 5px; color: #999">秒</span>
              </template>
            </div>
          </FormItem>
          <FormItem
            label="触发页面"
            :label-width="120"
            prop="controlGroupParam.position"
            :rules="[
              {
                required: true,
                type: 'number',
                message: '请选择触发页面',
                trigger: 'change'
              }
            ]"
          >
            <Select
              v-model="controlGroup.position"
              :disabled="disabled"
              placeholder="请选择触发页面"
              @on-change="controlGroup.triggerTiming = null"
            >
              <Option
                v-for="item in triggerPageOptions"
                :key="item.dictValue"
                :value="Number(item.dictValue)"
              >
                {{ item.dictName }}
              </Option>
            </Select>
          </FormItem>
          <FormItem
            label="触发操作"
            :label-width="120"
            prop="controlGroupParam.triggerTiming"
            :rules="[
              {
                required: true,
                type: 'number',
                message: '请选择触发操作',
                trigger: 'change'
              }
            ]"
          >
            <Select
              v-model="controlGroup.triggerTiming"
              :disabled="disabled || !controlGroup.position"
              placeholder="请选择触发操作"
            >
              <Option
                v-for="item in getTriggerActions(controlGroup.position)"
                :key="item.dictValue"
                :value="Number(item.dictValue)"
              >
                {{ item.dictName }}
              </Option>
            </Select>
          </FormItem>
          <FormItem
            label="推送弹窗"
            :label-width="120"
            prop="controlGroupParam.popupId"
            :rules="[
              {
                required: true,
                type: 'number',
                message: '请选择推送弹窗',
                trigger: 'change'
              }
            ]"
          >
            <Select
              v-model="controlGroup.popupId"
              :disabled="disabled"
              :loading="popupLoading"
              filterable
              placeholder="请输入弹窗备注名称搜索"
            >
              <Option
                v-for="item in popupOptions"
                :key="item.id"
                :value="item.id"
                :label="item.popupName"
              >
                {{ item.popupName }}
              </Option>
            </Select>
          </FormItem>
          <FormItem label="每日触发次数" :label-width="120">
            <RadioGroup
              :value="controlGroup.popupCount === 0 ? 0 : 1"
              type="button"
              :disabled="disabled"
              @on-change="handlePopupCountModeChange(controlGroup, $event)"
            >
              <Radio :label="0" :disabled="disabled">不限</Radio>
              <Radio :label="1" :disabled="disabled">限制次数</Radio>
            </RadioGroup>
            <InputNumber
              v-if="controlGroup.popupCount !== 0"
              v-model="controlGroup.popupCount"
              :min="1"
              :max="99"
              :precision="0"
              :disabled="disabled"
              style="width: 120px; margin-left: 10px"
            />
          </FormItem>
          <FormItem label="优先级" :label-width="120">
            <InputNumber
              v-model="controlGroup.priority"
              :min="1"
              :max="9999"
              :precision="0"
              :disabled="disabled"
              style="width: 200px"
            />
          </FormItem>
        </div>
      </div>

      <div
        v-for="(group, index) in formData.groups"
        :key="index"
        class="group-card"
      >
        <h3 class="group-title">实验组 {{ index + 1 }}</h3>
        <div class="group-fields">
          <FormItem :label-width="120" label="用户停留时长">
            <div class="duration-row">
              <Select
                v-model="group.experimentGroupParam.watchingDurationType"
                :disabled="disabled"
                style="width: 150px"
                @on-change="
                  handleDurationTypeChange(group.experimentGroupParam)
                "
              >
                <Option
                  v-for="item in durationTypeOptions"
                  :key="item.dictValue"
                  :value="Number(item.dictValue)"
                >
                  {{ item.dictName }}
                </Option>
              </Select>
              <template v-if="showDurationInput(group.experimentGroupParam)">
                <InputNumber
                  v-model="group.experimentGroupParam.durationMin"
                  :min="
                    group.experimentGroupParam.watchingDurationType === 2
                      ? 1
                      : 0
                  "
                  :max="9999"
                  :precision="0"
                  :disabled="disabled"
                  style="width: 100px; margin-left: 10px"
                />
                <span
                  v-if="showDurationRange(group.experimentGroupParam)"
                  style="margin: 0 5px"
                  >至</span
                >
                <InputNumber
                  v-if="showDurationRange(group.experimentGroupParam)"
                  v-model="group.experimentGroupParam.durationMax"
                  :min="0"
                  :max="9999"
                  :precision="0"
                  :disabled="disabled"
                  style="width: 100px"
                />
                <span style="margin-left: 5px; color: #999">秒</span>
              </template>
            </div>
          </FormItem>

          <FormItem
            :label-width="120"
            label="触发页面"
            :prop="`groups[${index}].experimentGroupParam.position`"
            :rules="[
              {
                required: true,
                type: 'number',
                message: '请选择触发页面',
                trigger: 'change'
              }
            ]"
          >
            <Select
              v-model="group.experimentGroupParam.position"
              :disabled="disabled"
              placeholder="请选择触发页面"
              @on-change="group.experimentGroupParam.triggerTiming = null"
            >
              <Option
                v-for="item in triggerPageOptions"
                :key="item.dictValue"
                :value="Number(item.dictValue)"
              >
                {{ item.dictName }}
              </Option>
            </Select>
          </FormItem>

          <FormItem
            :label-width="120"
            label="触发操作"
            :prop="`groups[${index}].experimentGroupParam.triggerTiming`"
            :rules="[
              {
                required: true,
                type: 'number',
                message: '请选择触发操作',
                trigger: 'change'
              }
            ]"
          >
            <Select
              v-model="group.experimentGroupParam.triggerTiming"
              :disabled="disabled || !group.experimentGroupParam.position"
              placeholder="请选择触发操作"
            >
              <Option
                v-for="item in getTriggerActions(
                  group.experimentGroupParam.position
                )"
                :key="item.dictValue"
                :value="Number(item.dictValue)"
              >
                {{ item.dictName }}
              </Option>
            </Select>
          </FormItem>

          <FormItem
            :label-width="120"
            label="推送弹窗"
            :prop="`groups[${index}].experimentGroupParam.popupId`"
            :rules="[
              {
                required: true,
                type: 'number',
                message: '请选择推送弹窗',
                trigger: 'change'
              }
            ]"
          >
            <Select
              v-model="group.experimentGroupParam.popupId"
              :disabled="disabled"
              :loading="popupLoading"
              filterable
              placeholder="请输入弹窗备注名称搜索"
            >
              <Option
                v-for="item in popupOptions"
                :key="item.id"
                :value="item.id"
                :label="item.popupName"
              >
                {{ item.popupName }}
              </Option>
            </Select>
          </FormItem>

          <FormItem :label-width="120" label="每日触发次数">
            <RadioGroup
              :value="group.experimentGroupParam.popupCount === 0 ? 0 : 1"
              type="button"
              :disabled="disabled"
              @on-change="
                handlePopupCountModeChange(group.experimentGroupParam, $event)
              "
            >
              <Radio :label="0" :disabled="disabled">不限</Radio>
              <Radio :label="1" :disabled="disabled">限制次数</Radio>
            </RadioGroup>
            <InputNumber
              v-if="group.experimentGroupParam.popupCount !== 0"
              v-model="group.experimentGroupParam.popupCount"
              :min="1"
              :max="99"
              :precision="0"
              :disabled="disabled"
              style="width: 120px; margin-left: 10px"
            />
          </FormItem>

          <FormItem
            :label-width="120"
            label="优先级"
            :prop="`groups[${index}].experimentGroupParam.priority`"
            :rules="[
              {
                required: true,
                type: 'number',
                message: '请输入优先级',
                trigger: 'blur'
              }
            ]"
          >
            <InputNumber
              v-model="group.experimentGroupParam.priority"
              :min="1"
              :max="9999"
              :precision="0"
              :disabled="disabled"
              style="width: 200px"
            />
          </FormItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPushInfo, getPushList } from '@/api/crowdPush'
import { getPopupList } from '@/api/popup'
import { getDictionaryList } from '@/api/dictionary'
import {
  buildActivityPushTemplatePayload,
  buildPushTriggerActionList,
  normalizeGroupParamByCapability
} from '../helpers'

export default {
  name: 'ActivityPushConfig',
  props: {
    formData: {
      type: Object,
      required: true
    },
    experimentGroupCount: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedRuleId: null,
      ruleLoading: false,
      popupLoading: false,
      ruleOptions: [],
      popupOptions: [],
      durationTypeOptions: [],
      triggerPageOptions: [],
      triggerActionOptions: []
    }
  },
  computed: {
    controlGroup() {
      return this.formData.controlGroupParam || {}
    },
    selectedCrowdIds() {
      return Array.isArray(this.formData.crowdIds) ? this.formData.crowdIds : []
    },
    selectedCrowdDeviceSys() {
      const selectedIds = this.selectedCrowdIds.map((item) => String(item))
      const crowdOptions = Array.isArray(this.formData.crowdOptions)
        ? this.formData.crowdOptions
        : []
      const deviceValues = Array.from(
        new Set(
          crowdOptions
            .filter((item) => selectedIds.includes(String(item.id)))
            .map((item) => this.normalizeCrowdDeviceSys(item && item.deviceSys))
            .filter((item) => item !== null)
        )
      )

      if (!deviceValues.length) return undefined
      if (deviceValues.includes(-1)) return -1
      if (deviceValues.length > 1) return -1
      return deviceValues[0]
    }
  },
  watch: {
    selectedCrowdIds: {
      deep: true,
      handler() {
        this.fetchRuleOptions()
        this.fetchPopups()
      }
    },
    selectedCrowdDeviceSys() {
      this.fetchPopups()
    },
    'formData.crowdOptions': {
      deep: true,
      handler() {
        this.fetchPopups()
      }
    }
  },
  created() {
    this.fetchDictionaries()
    this.fetchRuleOptions()
    this.fetchPopups()
    this.syncPopupOptionsFromForm()
  },
  methods: {
    normalizeCrowdDeviceSys(value) {
      const normalized = Number(value)
      return normalized === 0 || normalized === 1 || normalized === -1
        ? normalized
        : null
    },
    buildRuleQueryParams() {
      return {
        current: 1,
        size: 10000,
      }
    },
    async fetchDictionaries() {
      try {
        const [durationRes, positionRes, timingRes] = await Promise.all([
          getDictionaryList({ dictTopic: 'WATCHING_DURATION_TYPE' }),
          getDictionaryList({ dictTopic: 'POPUP_POSITION' }),
          getDictionaryList({ dictTopic: 'POPUP_TRIGGER_TIMING' })
        ])
        this.durationTypeOptions = durationRes.data.records || []
        this.triggerPageOptions = positionRes.data.records || []
        this.triggerActionOptions = timingRes.data.records || []
      } catch (error) {
        this.$Message.error('获取活动推送字典失败')
      }
    },
    async fetchRuleOptions() {
      this.ruleLoading = true
      try {
        const { data } = await getPushList(this.buildRuleQueryParams())
        this.ruleOptions = data.records || []
      } catch (error) {
        this.$Message.error('获取活动推送模板失败')
      } finally {
        this.ruleLoading = false
      }
    },
    async handleRuleChange(id) {
      if (!id) return
      try {
        const { data } = await getPushInfo(id)
        const template = buildActivityPushTemplatePayload(data)
        this.ensurePopupOption(template.popupId, data.popupName)
        this.formData.controlGroupParam = {
          ...this.formData.controlGroupParam,
          ...template
        }
        this.formData.groups.forEach((group) => {
          group.experimentGroupParam = {
            ...group.experimentGroupParam,
            ...template
          }
        })
      } catch (error) {
        this.$Message.error('获取活动推送模板详情失败')
      }
    },
    async fetchPopups() {
      this.popupLoading = true
      try {
        const params = {
          current: 1,
          size: 2000
        }

        if (this.selectedCrowdDeviceSys !== undefined) {
          params.deviceSys = this.selectedCrowdDeviceSys
        }

        const { data } = await getPopupList(params)
        this.popupOptions = data.records || []
      } catch (error) {
        this.$Message.error('获取弹窗列表失败')
      } finally {
        this.popupLoading = false
      }
    },
    ensurePopupOption(id, popupName) {
      if (!id || !popupName) return
      const exists = this.popupOptions.some((item) => item.id === id)
      if (exists) return
      this.popupOptions.push({
        id,
        popupName
      })
    },
    syncPopupOptionsFromForm() {
      const candidates = [
        this.formData.controlGroupParam,
        ...(this.formData.groups || []).map(
          (group) => group.experimentGroupParam
        )
      ]
      candidates.forEach((item) => {
        if (item && item.popupId && item.popupName) {
          this.ensurePopupOption(item.popupId, item.popupName)
        }
      })
    },
    applyDefaultGroup(defaultParam) {
      if (defaultParam && defaultParam.popupId && defaultParam.popupName) {
        this.ensurePopupOption(defaultParam.popupId, defaultParam.popupName)
      }
    },
    showDurationInput(param) {
      return Number(param && param.watchingDurationType) !== 0
    },
    showDurationRange(param) {
      return Number(param && param.watchingDurationType) === 3
    },
    handleDurationTypeChange(param) {
      if (!param) return
      const type = Number(param.watchingDurationType)
      if (type === 0) {
        param.durationMin = null
        param.durationMax = null
      } else if (type === 2) {
        param.durationMin = param.durationMin || 1
        param.durationMax = null
      } else if (type !== 3) {
        param.durationMax = null
      }
    },
    handlePopupCountModeChange(param, value) {
      if (!param) return
      param.popupCount = value === 0 ? 0 : param.popupCount || 1
    },
    getTriggerActions(position) {
      return buildPushTriggerActionList(position, this.triggerActionOptions)
    },
    validateDuration(param) {
      const type = Number(param.watchingDurationType)
      if (type === 0) return true
      if (!param.durationMin && param.durationMin !== 0) return false
      if (type === 3) {
        return param.durationMax !== null && param.durationMax !== undefined
      }
      return true
    },
    validate() {
      const configs = [
        normalizeGroupParamByCapability('8', this.formData.controlGroupParam),
        ...(this.formData.groups || []).map((group) =>
          normalizeGroupParamByCapability('8', group.experimentGroupParam)
        )
      ]

      return configs.every((config) => {
        if (
          !this.validateDuration(config) ||
          !config.position ||
          !config.triggerTiming ||
          !config.popupId ||
          !config.priority
        ) {
          this.$Message.error('请完善活动推送配置')
          return false
        }
        if (config.popupCount !== 0 && Number(config.popupCount) <= 0) {
          this.$Message.error('请输入有效的每日触发次数')
          return false
        }
        return true
      })
    }
  }
}
</script>

<style scoped lang="less">
.popup-config {
  margin: 20px 0;
}

.group-list {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.group-card {
  flex: 0 1 45%;
  box-sizing: border-box;
  border: 1px solid #e8eaec;
  padding: 20px;
  border-radius: 4px;
}

.group-title {
  margin-bottom: 20px;
}

.duration-row {
  display: flex;
  align-items: center;
}
</style>
